import "core-js/modules/es6.function.name";
import { loginByUsername, getUserInfo } from '@/api/login';
import { getToken, setToken, removeToken } from '@/utils/auth';
var user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    perms: [],
    setting: {
      articlePlatform: []
    }
  },
  mutations: {
    SET_CODE: function SET_CODE(state, code) {
      state.code = code;
    },
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
      state.introduction = introduction;
    },
    SET_SETTING: function SET_SETTING(state, setting) {
      state.setting = setting;
    },
    SET_STATUS: function SET_STATUS(state, status) {
      state.status = status;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_PERMS: function SET_PERMS(state, perms) {
      state.perms = perms;
    }
  },
  actions: {
    // 用户名登录
    LoginByUsername: function LoginByUsername(_ref, userInfo) {
      var commit = _ref.commit;
      var accountName = userInfo.accountName.trim();
      return new Promise(function (resolve, reject) {
        loginByUsername({
          empPhone: accountName,
          empPassword: userInfo.password
        }).then(function (response) {
          var data = response.data.data;
          commit('SET_TOKEN', data.token);
          commit('SET_NAME', data.name);
          commit('SET_AVATAR', data.headUrl);
          setToken(data.token);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 获取用户信息
    GetUserInfo: function GetUserInfo(_ref2) {
      var commit = _ref2.commit,
        state = _ref2.state;
      return new Promise(function (resolve, reject) {
        getUserInfo(state.token).then(function (response) {
          var data = response.data.data;
          if (data.perms && data.perms.length > 0) {
            // 验证返回的perms是否是一个非空数组
            commit('SET_PERMS', data.perms);
          } else {
            reject('getInfo: perms must be a non-null array !');
          }
          commit('SET_ROLES', data.roles);
          commit('SET_NAME', data.name);
          commit('SET_AVATAR', data.avatar);
          commit('SET_INTRODUCTION', data.introduction);
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    GetUserInfo2: function GetUserInfo2(_ref3) {
      var commit = _ref3.commit,
        state = _ref3.state;
      return new Promise(function (resolve, reject) {
        commit('SET_PERMS', '*');
        resolve({
          data: {
            data: '*'
          }
        });
        // response.data.data
        // getUserInfo(state.token).then(response => {
        //   const perms = response.data.data
        //   if (perms && perms.length > 0) { // 验证返回的perms是否是一个非空数组
        //     commit('SET_PERMS', perms)
        //   } else {
        //     reject('getInfo: perms must be a non-null array !')
        //   }
        //   commit('SET_ROLES', ['管理员'])
        //   commit('SET_NAME', '管理员')
        //   commit('SET_INTRODUCTION', '不知道是啥')
        //   resolve(response)
        // }).catch(error => {
        //   reject(error)
        // })
      });
    },
    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // 登出
    LogOut: function LogOut(_ref4) {
      var commit = _ref4.commit,
        state = _ref4.state;
      return new Promise(function (resolve, reject) {
        // logout(state.token).then(() => {
        //   commit('SET_TOKEN', '')
        //   commit('SET_ROLES', [])
        //   commit('SET_PERMS', [])
        //   removeToken()
        //   resolve()
        // }).catch(error => {
        //   reject(error)
        // })
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('SET_PERMS', []);
        removeToken();
        resolve();
      });
    },
    // 前端 登出
    FedLogOut: function FedLogOut(_ref5) {
      var commit = _ref5.commit;
      return new Promise(function (resolve) {
        commit('SET_TOKEN', '');
        removeToken();
        resolve();
      });
    },
    // 动态修改权限
    ChangeRoles: function ChangeRoles(_ref6, role) {
      var commit = _ref6.commit,
        dispatch = _ref6.dispatch;
      return new Promise(function (resolve) {
        commit('SET_TOKEN', role);
        setToken(role);
        getUserInfo(role).then(function (response) {
          var data = response.data;
          commit('SET_ROLES', data.roles);
          commit('SET_PERMS', data.perms);
          commit('SET_NAME', data.name);
          commit('SET_AVATAR', data.avatar);
          commit('SET_INTRODUCTION', data.introduction);
          dispatch('GenerateRoutes', data); // 动态修改权限后 重绘侧边菜单
          resolve();
        });
      });
    }
  }
};
export default user;